{
  "authFailure": {
    "title": "Trouble Logging In",
    "description": "An error occurred while attempting to log in. Please try again.",
    "button": "Back To Login"
  },
  "noCampAccess": {
    "title": "No Camp Access",
    "description": "Your account does not have access to any camps. Please reach out to your system administrator for further assistance.",
    "button": "Log Out"
  }
}
